<template>
  <div class="agent-empty">
    <img src="@/assets/images/agent/none.png" alt="" />
    <div class="empty-msg" v-if="msg">{{ msg }}</div>
    <div class="empty-desc" v-if="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'AgentEmpty',
  props: {
    msg: String,
    desc: String
  }
}
</script>

<style lang="scss" scoped>
.agent-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  img {
    width: 130px;
    height: 66px;
    margin-bottom: 24px;
    flex-shrink: 0;
  }
  .empty-msg {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
  }
  .empty-desc {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #60646b;
    line-height: 22px;
  }
}
</style>
